import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={`navbar ${isScrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__container">
        {/* Logo */}
        <Link to="/" className="navbar__logo">
          <picture>
            <source srcSet="/logo-circle.webp" type="image/webp" />
            <img
              src="/logo-circle-optimized.png"
              alt="Real Time Repairs"
              className="navbar__logo-image"
              width="40"
              height="40"
              fetchpriority="high"
            />
          </picture>
          <span className="navbar__logo-text">
            Real Time <span className="navbar__logo-accent">Repairs</span>
          </span>
        </Link>

        {/* Desktop Navigation */}
        <div className="navbar__nav">
          <Link to="/" className={`navbar__link ${isActive('/') ? 'navbar__link--active' : ''}`}>
            Home
          </Link>
          <Link to="/about" className={`navbar__link ${isActive('/about') ? 'navbar__link--active' : ''}`}>
            About
          </Link>
          <Link to="/resources" className={`navbar__link ${isActive('/resources') ? 'navbar__link--active' : ''}`}>
            Resources
          </Link>
          <Link to="/blog" className={`navbar__link ${isActive('/blog') ? 'navbar__link--active' : ''}`}>
            Blog
          </Link>
          <Link to="/contact" className={`navbar__link ${isActive('/contact') ? 'navbar__link--active' : ''}`}>
            Contact
          </Link>
        </div>

        {/* Desktop CTAs */}
        <div className="navbar__ctas">
          <a href="https://app.realtimerepairs.com/login" className="navbar__btn navbar__btn--outline">
            Log In
          </a>
          <a href="https://app.realtimerepairs.com/register" className="navbar__btn navbar__btn--primary">
            Get Started Free
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className={`navbar__mobile-toggle ${isMobileMenuOpen ? 'navbar__mobile-toggle--open' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span className="navbar__mobile-toggle-bar"></span>
          <span className="navbar__mobile-toggle-bar"></span>
          <span className="navbar__mobile-toggle-bar"></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`navbar__mobile-menu ${isMobileMenuOpen ? 'navbar__mobile-menu--open' : ''}`}>
        <div className="navbar__mobile-nav">
          <Link to="/" className={`navbar__mobile-link ${isActive('/') ? 'navbar__mobile-link--active' : ''}`}>
            Home
          </Link>
          <Link to="/about" className={`navbar__mobile-link ${isActive('/about') ? 'navbar__mobile-link--active' : ''}`}>
            About
          </Link>
          <Link to="/resources" className={`navbar__mobile-link ${isActive('/resources') ? 'navbar__mobile-link--active' : ''}`}>
            Resources
          </Link>
          <Link to="/blog" className={`navbar__mobile-link ${isActive('/blog') ? 'navbar__mobile-link--active' : ''}`}>
            Blog
          </Link>
          <Link to="/contact" className={`navbar__mobile-link ${isActive('/contact') ? 'navbar__mobile-link--active' : ''}`}>
            Contact
          </Link>
        </div>
        <div className="navbar__mobile-ctas">
          <a href="https://app.realtimerepairs.com/login" className="navbar__btn navbar__btn--outline navbar__btn--full">
            Log In
          </a>
          <a href="https://app.realtimerepairs.com/register" className="navbar__btn navbar__btn--primary navbar__btn--full">
            Get Started Free
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
